'use client';

import { Icon } from '@polyseme/design-system';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

import { Button } from '~/landing/components/shared';

import { Title } from '../components/title';
import { Typography } from '../components/typography';
import { contactId } from '../constants';
import { Compare } from './compare';
import { Testimony } from './testimony';

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

export const TestimonialsSection = () => {
  const t = useTranslations('landing.polyseme.testimonials');
  return (
    <section
      className="mx-auto flex w-full max-w-screen-xl flex-col px-4"
      id="testimonials"
    >
      <motion.div
        className="py-[120px] text-center"
        initial="hidden"
        transition={{ duration: 0.5, ease: 'easeOut' }}
        variants={fadeInUp}
        viewport={{ once: true, amount: 0.3 }}
        whileInView="visible"
      >
        <Title
          as="h2"
          className="mb-4 whitespace-pre-wrap text-center"
          variant="title-2"
        >
          {t('demo.title')}
        </Title>
        <Typography className="mx-auto max-w-2xl text-balance text-muted-foreground">
          {t('demo.description')}
        </Typography>
        <Button asChild className="mt-10 w-full sm:w-auto" size="xl">
          <Link href={`#${contactId}`}>
            {t('demo.cta')}
            <Icon name="circle-play" />
          </Link>
        </Button>
      </motion.div>
      <Compare />
      <Testimony />
    </section>
  );
};
